/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { Condition } from './Condition';
import {
  ConditionFromJSON,
  ConditionFromJSONTyped,
  ConditionToJSON,
} from './Condition';
import type { RuleSettings } from './RuleSettings';
import {
  RuleSettingsFromJSON,
  RuleSettingsFromJSONTyped,
  RuleSettingsToJSON,
} from './RuleSettings';

/**
 *
 * @export
 * @interface RulePost
 */
export interface RulePost {
  /**
   * Campaign rule gets added to
   * @type {string}
   * @memberof RulePost
   */
  campaignId?: string;
  /**
   * Rule conditions
   * @type {Array<Condition>}
   * @memberof RulePost
   */
  conditions?: Array<Condition>;
  /**
   * Rule settings in dict
   * @type {RuleSettings}
   * @memberof RulePost
   */
  settings?: RuleSettings;
  /**
   * Rule Type
   * @type {string}
   * @memberof RulePost
   */
  type: RulePostTypeEnum;
}

/**
 * @export
 */
export const RulePostTypeEnum = {
  Call: 'call',
  Sms: 'sms',
} as const;
export type RulePostTypeEnum =
  (typeof RulePostTypeEnum)[keyof typeof RulePostTypeEnum];

/**
 * Check if a given object implements the RulePost interface.
 */
export function instanceOfRulePost(value: object): value is RulePost {
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function RulePostFromJSON(json: any): RulePost {
  return RulePostFromJSONTyped(json, false);
}

export function RulePostFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RulePost {
  if (json == null) {
    return json;
  }
  return {
    campaignId: json['campaign_id'] == null ? undefined : json['campaign_id'],
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ConditionFromJSON),
    settings:
      json['settings'] == null
        ? undefined
        : RuleSettingsFromJSON(json['settings']),
    type: json['type'],
  };
}

export function RulePostToJSON(value?: RulePost | null): any {
  if (value == null) {
    return value;
  }
  return {
    campaign_id: value['campaignId'],
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ConditionToJSON),
    settings: RuleSettingsToJSON(value['settings']),
    type: value['type'],
  };
}
